import { RegionTypes } from '../constants/regionType';

export const buildSiblingRegionUrl = (
	currentRegion,
	adminUrl,
	adminUrlSa,
	pathname,
	search,
	hash
) => {
	const siblingOrigin =
		currentRegion === RegionTypes.SaudiArabia ? adminUrl : adminUrlSa;

	if (!siblingOrigin) {
		return null;
	}

	return `${siblingOrigin}${pathname}${search}${hash}`;
};
